



































































































































































import {Component, Prop, Model} from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import {BusEvent} from '@/models/bus';

import Modal from '@/components/Modal.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import Media from "@/api/media";
import ExtraLine from "@/api/extraLine";
import FieldAudio from "@/components/FieldAudio.vue";
import FieldInternational from "@/components/FieldInternational.vue";
import FieldExtraPhonemes from "@/components/FieldExtraPhonemes.vue";
import Hint from "@/api/hint";

@Component({
    components: {
        'field-extra-phonemes': FieldExtraPhonemes,
        'modal': Modal,
        'edit-icon': EditIcon,
        'field-audio': FieldAudio,
        'field-international': FieldInternational,
    },
})
export default class FieldExtraLine extends CommonVue {
    @Model('update') public extra_line_list!: ExtraLine[];
    @Prop({type: Boolean, default: false}) public disabled?: boolean;
    @Prop({type: Number}) public parentId!: number;
    @Prop({type: Boolean, default: false}) public phonemes_enabled?: boolean;

    public extra_line: ExtraLine = null;
    public showModal: boolean = false;

    // noinspection JSMethodCanBeStatic
    public edit(extra_line: ExtraLine) {
        this.extra_line = extra_line;
        this.showModal = true;
    }

    public newExtraLine() {
        this.extra_line = new ExtraLine();
        this.extra_line.parent_id = this.parentId;
        this.showModal = true;
    }

    public async saveClicked() {
        if (!this.extra_line) {
            return;
        }

        this.busy = true;

        try {
            this.checkMandatoryFields();
            if (this.extra_line.state === 'created') {
                this.extra_line_list.push(this.extra_line);
            }
            this.extra_line.state = "updated";
            this.busy = false;
            this.showModal = false;
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save extra line', e);
        }
    }

    public static async saveExtraLines(extra_lines: ExtraLine[], parent_id: number, parent_model: string) {
        for (let extra_line of extra_lines) {
            if (extra_line.state === 'updated') {
                if (!extra_line.id) {
                    extra_line.parent_model = parent_model;
                    extra_line.parent_id = parent_id;
                }
                await FieldExtraLine.saveExtraLine(extra_line);
            } else if (extra_line.state === 'deleted' && extra_line.id) {
                extra_line = new ExtraLine().assign(extra_line);
                await extra_line.delete();
            }
        }
    }

    public static async saveExtraLine(extra_line: ExtraLine) {
        if (!extra_line.id) {
            extra_line.id = await extra_line.save();
        }
        await FieldExtraLine.saveMediaFiles(extra_line);
        extra_line = new ExtraLine().assign(extra_line);
        await extra_line.save();
    }

    public static async saveMediaFiles(extra_line: ExtraLine) {
        if (extra_line.audio_file) {
            const audio = await Media.createAudio(
                extra_line.audio_file,
                "extraline",
                extra_line.id,
                'audio_path'
            );
            if (audio !== null) {
                extra_line.audio_path = audio;
            }
        } else if (extra_line.audio_file === null) {
            await Media.deleteAudio(extra_line.audio_path);
            extra_line.audio_path = undefined;
        }
    }

    public checkMandatoryFields() {
        // Check if text is filled
        if(!this.extra_line.sentence) {
            throw Error('Please insert the sentence.');
        }
        return;
    }

    public async deleteClicked() {
        const newList = this.extra_line_list.filter((value) => {
            return value !== this.extra_line;
        });
        this.extra_line.state = "deleted";
        this.$emit('update', newList);
        this.showModal = false;
    }

}

